
import { ArrowDownCircle, ArrowUpCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Product } from "@/lib/types";
import StatsCard from "./StatsCard";

interface OverallSummaryProps {
  totalUsage: number;
  totalStockAdded: number;
  lowStockProducts: Product[];
}

const OverallSummary = ({ totalUsage, totalStockAdded, lowStockProducts }: OverallSummaryProps) => {
  return (
    <>
      <h2 className="text-xl font-semibold mb-4">Overall Summary</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <StatsCard
          title="Total Usage"
          value={totalUsage}
          icon={<ArrowDownCircle className="h-5 w-5 text-red-500 mr-2" />}
          badgeText="Used"
          badgeColor="bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100"
        />
        
        <StatsCard
          title="Total Stock Added"
          value={totalStockAdded}
          icon={<ArrowUpCircle className="h-5 w-5 text-green-500 mr-2" />}
          badgeText="Added"
          badgeColor="bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100"
        />
        
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-500 dark:text-gray-400">
              Low Stock Products
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center">
              <span className="text-2xl font-bold">{lowStockProducts.length}</span>
              <Badge className="ml-2 bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100">
                Alert
              </Badge>
            </div>
            <div className="mt-2 text-sm">
              {lowStockProducts.length > 0 ? (
                <ul className="list-disc pl-5">
                  {lowStockProducts.slice(0, 3).map(product => (
                    <li key={product.id}>{product.name}</li>
                  ))}
                  {lowStockProducts.length > 3 && (
                    <li>And {lowStockProducts.length - 3} more...</li>
                  )}
                </ul>
              ) : (
                <p className="text-gray-500">All products have sufficient stock</p>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default OverallSummary;
